export { buildPortalLoginCallbackUrl } from "./platform-url-portal-login";
export type { IAiPlatformServiceKey } from "./platform-url-registry";
export type {
  IAiViteConfigEnv,
  IAiViteHmrOptions,
} from "./platform-url-root-domain";
export {
  getIAiPlatformRootDomains,
  getIAiViteAllowedHosts,
  getIAiViteHmrOptions,
  isIAiPlatformHost,
  requireIAiViteHmrHost,
  resolveIAiSubdomainUrl,
  resolvePlatformRootDomain,
} from "./platform-url-root-domain";
export type {
  IAiBrowserPublicServiceEnvReader,
  IAiBrowserPublicServiceUrlOptions,
} from "./platform-url-service-resolver";
export {
  normalizeIAiPublicServiceRootUrl,
  resolveIAiApiBaseUrl,
  resolveIAiBrowserPublicServiceBaseUrl,
  resolveIAiDefaultServiceUrl,
  resolveIAiGeneratedBrowserPublicServiceBaseUrl,
  resolveIAiLocalServiceUrl,
  resolveIAiPlatformServiceUrl,
} from "./platform-url-service-resolver";
export { formatIAiPublicUrlLabel } from "./platform-url-utils";
